export enum DocumentReference {
  DocumentType = 'DocumentType',
  Upload = 'Upload'
}
